(ns app.components.folder-items.views
  (:require-macros
   [re-com.core  :refer [handler-fn]])
  (:require [app.components.buttons.styles :as styles :refer [selected-folder-item selected-folder-item-of-untitled]]
            [app.components.icons.views :refer [folder-icon]]
            [app.components.input-field.views :refer [folder-item-content-editable]]
            [app.components.menus.views :refer [folder-item-menu-component folder-item-ellipsis-menu]]
            [re-com.core :as re-com :refer [at h-box]]
            [reagent.core   :as    reagent]))

(defn handle-context-menu-fn [context-menu type id clicked-folder-details clicked-workspace-id clicked-workspace-name count delete-notification]
  (fn [^js/Event e]
    (.preventDefault e)
    (when (nil? @context-menu)
      (reset! delete-notification false)
      (reset! context-menu {:mouse-x (+ (.-clientX e) 2) :mouse-y (- (.-clientY e) 6) :type type :id id})
      (reset! clicked-folder-details {:folder-id clicked-workspace-id :folder-name (if (= clicked-workspace-name "") "Untitled" clicked-workspace-name) :count count}))))

(defn folder-item [{:keys [name editable selected onClick onChange onDelete confirmDelete copyLink workspace-id folder-id new-folder? deletable? clicked-folder-details clicked-workspace-id clicked-workspace-name count delete-notification]}]
  (let [context-menu (reagent/atom nil)
        hover? (reagent/atom false)
        text-val (reagent/atom name)
        label-clicked-out? (reagent/atom false)
        delete-action (if (not= deletable? true) confirmDelete onDelete)]
    (fn []
      [:div {:onContextMenu (handle-context-menu-fn context-menu :folder-item nil clicked-folder-details clicked-workspace-id clicked-workspace-name count delete-notification) :style {:cursor "context-menu"}}
       [re-com/button
        :src       (at)
        :label
        [h-box
         :size "auto"
         :justify :between
         :children [[folder-item-content-editable {:icon folder-icon :name name :text-val text-val :onChange onChange
                                                   :workspace-id workspace-id :folder-id folder-id :label-clicked-out? label-clicked-out?
                                                   :new-folder? new-folder? :selected selected}]
                    (when (or selected @hover?) [h-box
                                                 :children [[folder-item-ellipsis-menu folder-id delete-action copyLink label-clicked-out? clicked-folder-details clicked-workspace-id clicked-workspace-name count hover?]
                                                            [folder-item-menu-component delete-action copyLink label-clicked-out? context-menu hover?]]
                                                 :height "24px"])] :align :center]
        :class (if (= selected true) (selected-folder-item-of-untitled name) (styles/folder-item-of-untitled name))
        :on-click onClick
        :attr     {:on-mouse-enter #(do
                                      (reset! hover? true))
                   :on-mouse-leave  #(do
                                       (reset! hover? false))
                   :on-key-up (fn [^js/Event e]
                                (when (= (-> e .-which) 32)
                                  (.preventDefault e)))}]])))
